var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "catalog__controls-sort catalog__header-col" },
    [
      _c("div", { staticClass: "catalog__sort sort pure-g" }, [
        _c("span", { staticClass: "sort__caption pure-u-2-5" }, [
          _vm._v("Сортировать по:"),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "pure-u-3-5" },
          [
            _c("vue-select", {
              attrs: { default: _vm.defOption, options: _vm.options },
              on: { changeSelect: _vm.onSort },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }